/*
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([], () => {
	/**
	 * @interface SerializerAPI
	 * @hideconstructor
	 * @classdesc API class for the Dashboard Serializer feature, which allows the generation of a JS object representing the dashboard.
	 * @example dashboard.getFeature('Serializer')
	 */
	class SerializerAPI {
		/**
		 * Calling this method builds and return a JS object representing the current dashboard.
		 * If given a list of content IDs, a minimum dashboard spec (containing the specified IDs) will be returned.
		 * @param {Object} [options] Options used to generate a dashboard spec.
		 * @param {Array} options.contentIds List of content IDs
		 * @param {Array} options.dashboardFeatures List of dashboard features to include in the spec,
		 * 	include all features by default.
		 * @returns {object} JS object representing the current dashboard
		 */
		toJSON() { }
	}

	return SerializerAPI;
});
